import React from 'react';
import style from './HeadersUsers.module.css';

const HeadersUsers = () => {
    return (
        <div className={style.headersLineUsers}>

        </div>
    )
}

export default HeadersUsers;